import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatEUR } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Gift, Lightning, FileText, Crown, ArrowRight, X } from "@phosphor-icons/react";

const OPTIONS = [
    { icon: Lightning, title: "Dictamen Pre-Bancario", price: 14, desc: "9 ratios bancarios, veredicto verde/ámbar/rojo y simulador Antes/Después.", to: "/maquina-verdad", testId: "welcome-opt-dictamen" },
    { icon: FileText, title: "Informe Financiero", price: 24, desc: "Balance Básico interpretado con IA: 8 ratios, alertas y consejos.", to: "/analisis/nuevo", testId: "welcome-opt-informe" },
    { icon: Crown, title: "Informe Master", price: 44, desc: "Auditoría bancaria completa sobre un informe previo (Deuda/EBITDA, DSCR).", to: "/dashboard?master=1", testId: "welcome-opt-master" },
];

export default function WelcomeModal() {
    const { user, refresh } = useAuth();
    const [closed, setClosed] = useState(false);
    const show = user && user.welcome_credits_granted && !user.welcome_seen && !closed;
    if (!show) return null;

    async function dismiss() {
        setClosed(true);
        try { await api.post("/auth/welcome-seen"); if (refresh) refresh(); } catch { /* silent */ }
    }

    const credits = Number(user.credits_eur || 0);
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[var(--gf-navy)]/70 backdrop-blur-sm px-4" data-testid="welcome-modal">
            <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} className="bg-white w-full max-w-2xl shadow-2xl border-t-4 border-t-[var(--gf-gold)] relative">
                <button onClick={dismiss} className="absolute top-4 right-4 text-[var(--gf-text-muted)] hover:text-[var(--gf-navy)]" aria-label="Cerrar" data-testid="welcome-close">
                    <X size={20} />
                </button>
                <div className="p-8 md:p-10">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="w-12 h-12 bg-[var(--gf-gold)]/15 flex items-center justify-center">
                            <Gift size={26} weight="fill" className="text-[var(--gf-gold)]" />
                        </div>
                        <div className="micro-label">— Bienvenida</div>
                    </div>
                    <h2 className="serif text-3xl md:text-4xl text-[var(--gf-navy)] leading-tight mb-3">
                        Hola{user.name ? `, ${user.name}` : ""}. Tienes <span className="italic text-[var(--gf-gold)]" data-testid="welcome-credits">{formatEUR(credits)}</span> en créditos.
                    </h2>
                    <p className="text-sm text-[var(--gf-text-secondary)] leading-relaxed mb-6">
                        Te hemos regalado <strong>50 créditos de bienvenida</strong> (1 € = 1 crédito). Sin tarjeta y sin caducidad. Esto es lo que puedes hacer hoy mismo con ellos:
                    </p>
                    <div className="grid sm:grid-cols-3 gap-3 mb-6">
                        {OPTIONS.map((o) => (
                            <Link key={o.title} to={o.to} onClick={dismiss} className="group border border-[var(--gf-border)] hover:border-[var(--gf-gold)] p-4 flex flex-col transition-colors" data-testid={o.testId}>
                                <o.icon size={22} weight="light" className="text-[var(--gf-navy)] mb-3" />
                                <div className="font-semibold text-sm text-[var(--gf-navy)]">{o.title}</div>
                                <div className="mono text-xs text-[var(--gf-gold)] mb-2">{o.price} créditos</div>
                                <p className="text-[11px] text-[var(--gf-text-secondary)] leading-relaxed flex-1">{o.desc}</p>
                                <span className="text-[11px] text-[var(--gf-gold)] inline-flex items-center gap-1 mt-3 group-hover:gap-2 transition-all">Empezar <ArrowRight size={12} /></span>
                            </Link>
                        ))}
                    </div>
                    <p className="text-[11px] text-[var(--gf-text-muted)] mb-5">
                        Con 50 créditos puedes pedir un Dictamen Pre-Bancario (14) y un Informe Financiero (24) y aún te sobran 12. También tienes acceso al OCR de facturas (0,25/factura) y a Verifactu.
                    </p>
                    <div className="flex flex-wrap gap-3 justify-end">
                        <Link to="/pagos" onClick={dismiss} className="btn-outline text-sm" data-testid="welcome-tarifas">Ver tarifas</Link>
                        <button onClick={dismiss} className="btn-gold text-sm" data-testid="welcome-start">Entendido, empezar <ArrowRight size={14} /></button>
                    </div>
                </div>
            </motion.div>
        </div>
    );
}
